var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcaseBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 8,
    viewBox: "0 0 26 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.25L9.5359 2.75L16.4641 2.75L13 7.25Z",
    fill: "#5B4E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseBottomArrow);
export default __webpack_public_path__ + "static/media/showcaseBottomArrow.7295ca484320f88cc8e42f8f62fbd12c.svg";
export { ForwardRef as ReactComponent };